<template>
  <div class="index">
    <header>
      <img src="../assets/woyaobangding_bg_logo@2x.png" />
    </header>
    <div class="main">
      <yd-cell-group>
        <yd-cell-item>
          <input slot="right" type="number" placeholder="请输入手机号" />
        </yd-cell-item>
      </yd-cell-group>
    </div>
    <footer></footer>
  </div>
</template>

<script>
import util from "../utils/util";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  created() {
    console.log(process.env.NODE_ENV);
  },
  methods: {

  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue